import { render, staticRenderFns } from "./VisitRequestProposal.vue?vue&type=template&id=5fdab59a&scoped=true"
import script from "./VisitRequestProposal.vue?vue&type=script&lang=js"
export * from "./VisitRequestProposal.vue?vue&type=script&lang=js"
import style0 from "./VisitRequestProposal.vue?vue&type=style&index=0&id=5fdab59a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdab59a",
  null
  
)

export default component.exports